/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unescaped-entities */
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, Row, Table, Alert } from 'react-bootstrap';
import Drawer from 'react-modern-drawer';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { toast } from 'react-hot-toast';
import guessFormat from 'moment-guess';
import moment from 'moment';
import _ from 'lodash';
import { loaderActions } from '../../../../../features/Loader/LoaderSlice';
import API from '../../../../../Services/API';
import { sortLinesByErrors } from '../../../../../Helpers/sort';
import OrderLine from '../../../../../components/shared/OrderLine/Index';
import { validatePurchaseLine, isSeafreightShipped } from '../../../../../Helpers/line.validation';
import { useCurrentCompanyFullName } from '../../../../../hooks/useCurrentCompany';

function ImportSupplierPOs() {
  const dispatch = useDispatch();
  const companyFullName = useCurrentCompanyFullName();
  const inputEl = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [isErrorDrawerOpen, setIsErrorDrawerOpen] = useState(false);
  const [uploadedLines, setUploadedLines] = useState([]);
  const [uploadedOrders, setUploadedOrders] = useState([]);
  const [dynamicsSaveErrors, setDynamicsSaveErrors] = useState([]);
  const [dynamicsMissingErrors, setDynamicsMissingErrors] = useState([]);
  const { isFeedBackLoopEnabled } = useSelector((state) => state.general);

  const importPOs = () => {
    const line1Text = `For Suppliers PO's`;
    const fieldsList = `<br />
    <ol start="1" class="text-left" style="color: red">
        <li>Vendor Confirm Quantity</li>
        <li>Vendor Shipment Number</li>
        <li>Root Cause</li>
        <li>Expected GRD</li>
        <li>Country Of Origin (required)</li>
        <li>Confirmed Unit Price(Only if not saved yet)</li>
    </ol>`;
    Swal.fire({
      title: 'Mass Upload info',
      icon: 'info',
      html: `${line1Text}, Only following fields are updatable: <br />` + `${fieldsList} `,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="feather icon-thumbs-up"></i> Great!',
      confirmButtonAriaLabel: 'Thumbs up, great!',
      cancelButtonText: '<i class="feather icon-thumbs-down"></i>',
      cancelButtonAriaLabel: 'Thumbs down'
    }).then((result) => {
      if (result.isConfirmed) {
        inputEl.current.click();
      }
    });
  };

  async function handleFileChange(e) {
    if (e.target.files) {
      PurchaseExcelToJSON(e.target.files[0], 'supplier');
    }
    e.target.value = null;
  }

  function ExcelDateToJSDate(serial) {
    const utcDays = Math.floor(serial - 25569);
    const utcValue = utcDays * 86400;
    const dateInfo = new Date(utcValue * 1000);
    return `${dateInfo.getFullYear()}-${(dateInfo.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${dateInfo.getDate().toString().padStart(2, '0')}`;
  }

  function ExcelDateToEVPFormat(date) {
    if (date) {
      const currentFormat = guessFormat(date);
      return moment(date, currentFormat).format('YYYY-MM-DD');
    } else {
      return date;
    }
  }

  const PurchaseExcelToJSON = async (file, vendorType) => {
    dispatch(loaderActions.show());
    const reader = new FileReader();
    reader.onload = async function (e) {
      const binaryString = e.target.result;
      // convert the binary string to a workbook
      const workbook = XLSX.read(binaryString, { type: 'binary' });
      // get the first sheet
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      // convert the sheet to JSON
      const rows = XLSX.utils.sheet_to_json(sheet);
      const rowsData = rows.filter((row) => row.Type === 'purchase');
      if (rowsData.length === 0) {
        toast.error(`No Purchase Orders matching for suppliers`);
        dispatch(loaderActions.hide());
        throw new Error('No Purchase Orders matching for suppliers.');
      } else {
        const lines = rows.map((line) => {
          if (
            line['Expected GRD (yyyy/mm/dd)'] &&
            typeof line['Expected GRD (yyyy/mm/dd)'] === 'number'
          ) {
            line['Expected GRD (yyyy/mm/dd)'] = ExcelDateToJSDate(
              line['Expected GRD (yyyy/mm/dd)']
            );
          } else {
            line['Expected GRD (yyyy/mm/dd)'] = ExcelDateToEVPFormat(
              line['Expected GRD (yyyy/mm/dd)']
            );
          }
          // Expected Delivery Date
          if (
            line['Expected Delivery Date (yyyy/mm/dd)'] &&
            typeof line['Expected Delivery Date (yyyy/mm/dd)'] === 'number'
          ) {
            line['Expected Delivery Date (yyyy/mm/dd)'] = ExcelDateToJSDate(
              line['Expected Delivery Date (yyyy/mm/dd)']
            );
          } else {
            line['Expected Delivery Date (yyyy/mm/dd)'] = ExcelDateToEVPFormat(
              line['Expected Delivery Date (yyyy/mm/dd)']
            );
          }
          // Actual Shipping Date
          if (
            line['Actual Shipping Date (yyyy/mm/dd)'] &&
            typeof line['Actual Shipping Date (yyyy/mm/dd)'] === 'number'
          ) {
            line['Actual Shipping Date (yyyy/mm/dd)'] = ExcelDateToJSDate(
              line['Actual Shipping Date (yyyy/mm/dd)']
            );
          } else {
            line['Actual Shipping Date (yyyy/mm/dd)'] = ExcelDateToEVPFormat(
              line['Actual Shipping Date (yyyy/mm/dd)']
            );
          }
          return {
            documentNo: line['Order No'],
            lineNo: line['Line No'],
            itemNo: line['Item No'],
            description: line.Description,
            vndrShpmntNo: String(line['Vendor Shipment Number']),
            locationCode: line['Location Code'],
            vendorConfirmQty: Number(line['Vendor Confirm Quantity']),
            expectedReceiptDate: line['Expected GRD (yyyy/mm/dd)'],
            whseConfirmQty: Number(line['Warehouse Confirm Quantity']),
            actualReceiptDate: line['Actual Receipt Date (yyyy/mm/dd)'],
            qtyDmged: Number(line['Quantity Damaged']),
            mfgOriginCountry: line['Country Of Origin'],
            vpDirectUnitCost: Number(line['Confirmed Unit Price']),
            isValid: true,
            editedFields: [],
            validationErrors: [],
            validationWarnings: []
          };
        });
        setUploadedLines(lines);
        LoadOrdersData(lines, vendorType);
      }
    };

    reader.onerror = function (ex) {
      throw new Error('Error reading file.');
    };
    reader.readAsBinaryString(file);
  };

  async function LoadOrdersData(lines, vendorType) {
    const uniqueOrders = [...new Set(lines.map((line) => line.documentNo))];

    const commonSelectParams = {
      $select: 'docNo,status,vendorPortalStatus,vendorPortalStatusCaption'
    };

    const vendorParams = {
      Emma: {
        company_id: process.env.REACT_APP_COMP_EMM
      },
      Dun: {
        company_id: process.env.REACT_APP_COMP_DUN
      }
    };

    const fetchOrders = async (vendor) => {
      const params = { ...vendor, ...commonSelectParams };
      const response = await API().get('/purchase_order_header', { params });
      return response?.data?.value || [];
    };

    try {
      // Fetch data from both vendors in parallel
      const [emmaOrders, dunOrders] = await Promise.all([
        fetchOrders(vendorParams.Emma),
        fetchOrders(vendorParams.Dun)
      ]);

      // Combine and filter the results
      const ordersList = [...emmaOrders, ...dunOrders].filter(
        (order) => order && uniqueOrders.includes(order.docNo)
      );

      setUploadedOrders(ordersList);

      return await LoadPurchaseLinesData(lines, vendorType);
    } catch (error) {
      console.error('Error loading orders data:', error);
      throw error;
    }
  }

  async function FetchPurchaseOrderLines(lines) {
    const uniqueOrders = [...new Set(lines.map((line) => line.documentNo))];

    const selectFields = [
      'documentNo',
      'lineNo',
      'quantity',
      'originalQuantity',
      'qtyReceived',
      'mfgOriginCountry',
      'vendorConfirmQty',
      'expectedReceiptDate',
      'expectedDeliveryDate',
      'actualShippingDate',
      'vendorPortalStatus',
      'vendorPortalStatusCaption',
      'overReceiptCode',
      'feedbackDate',
      'feedbackStatus',
      'feedbackType',
      'feedbackUser',
      'directUnitCost',
      'vpFreightType',
      'seaFreightConfirmedQty',
      'vpDirectUnitCost'
    ];

    const commonSelectParams = {
      $select: selectFields.join(',')
    };

    const vendorParams = {
      Emma: { company_id: process.env.REACT_APP_COMP_EMM },
      Dun: { company_id: process.env.REACT_APP_COMP_DUN }
    };

    const fetchOrderLines = async (vendor) => {
      const params = { ...vendor, ...commonSelectParams };
      const response = await API().get('/purchase_order_lines', { params });
      return response?.data?.value || [];
    };

    try {
      const [emmaLines, dunLines] = await Promise.all([
        fetchOrderLines(vendorParams.Emma),
        fetchOrderLines(vendorParams.Dun)
      ]);

      const res = [...emmaLines, ...dunLines].filter(
        (line) => line && uniqueOrders.includes(line.documentNo)
      );
      return res;
    } catch (error) {
      console.error('Error fetching order lines:', error);
      throw error;
    }
  }

  async function LoadPurchaseLinesData(lines, VendorType) {
    const res = await FetchPurchaseOrderLines(lines);
    let updatedLines = [];
    lines.forEach((targetLine) => {
      const updateLine = res.find(
        (line) => line.documentNo === targetLine.documentNo && line.lineNo === targetLine.lineNo
      );
      if (updateLine) {
        let qtyMissing =
          updateLine.vendorConfirmQty - (updateLine.qtyReceived + targetLine.whseConfirmQty);
        if (qtyMissing < 0) {
          qtyMissing = 0;
        }
        updatedLines.push({
          ...targetLine,
          id: `${targetLine.documentNo}_${targetLine.lineNo}`,
          qtyMissing,
          actualShippingDate: updateLine.actualShippingDate,
          vendorPortalStatus: updateLine.vendorPortalStatus,
          vendorPortalStatusCaption: updateLine.vendorPortalStatusCaption,
          quantity: updateLine.quantity,
          vpFreightType: updateLine.vpFreightType,
          originalQuantity: updateLine.originalQuantity,
          qtyReceived: updateLine.qtyReceived,
          feedbackDate: updateLine.feedbackDate,
          feedbackStatus: updateLine.feedbackStatus,
          feedbackType: updateLine.feedbackType,
          feedbackUser: updateLine.feedbackUser,
          overReceiptCode: updateLine.overReceiptCode,
          directUnitCost: updateLine.directUnitCost,
          vpDirectUnitCost: updateLine.vpDirectUnitCost
            ? updateLine.vpDirectUnitCost
            : targetLine.vpDirectUnitCost,
          isVpDirectUnitCostEditable: !updateLine.vpDirectUnitCost
        });
      } else {
        setDynamicsMissingErrors((prev) => {
          const errorsList = [
            ...prev,
            {
              documentNo: targetLine.documentNo,
              lineNo: targetLine.lineNo,
              id: `${targetLine.documentNo}_${targetLine.lineNo}`
            }
          ];
          return _.uniqBy(errorsList, 'id');
        });
      }
    });
    updatedLines = _.uniqBy(updatedLines, 'id');
    setUploadedLines(sortLinesByErrors(updatedLines));
    toggleDrawer();
  }

  const toggleDrawer = () => {
    if (isOpen) {
      setUploadedLines([]);
      setUploadedOrders([]);
    }
    setIsOpen((prevState) => !prevState);
    setTimeout(() => {
      dispatch(loaderActions.hide());
    }, 1000);
  };

  const toggleErrorDrawer = () => {
    if (isErrorDrawerOpen) {
      setDynamicsSaveErrors([]);
      setDynamicsMissingErrors([]);
    }
    setIsErrorDrawerOpen((prevState) => !prevState);
  };

  function editValue(documentNo, lineNo, targetField) {
    const targetKey = Object.keys(targetField)[0];
    setUploadedLines((prevState) => {
      return prevState.map((line) => {
        if (line.documentNo === documentNo && lineNo === line.lineNo) {
          line[targetKey] = targetField[targetKey];
        }
        return line;
      });
    });

    if (targetKey === 'whseConfirmQty' && targetField[targetKey] > 0) {
      setUploadedLines((prevState) => {
        return prevState.map((line) => {
          if (line.documentNo === documentNo && lineNo === line.lineNo) {
            let qtyMissing = line.vendorConfirmQty - (line.qtyReceived + targetField[targetKey]);
            if (qtyMissing < 0) {
              qtyMissing = 0;
            }
            line.qtyMissing = qtyMissing;
          }
          return line;
        });
      });
    }

    if (targetKey === 'qtyToReceive' && targetField[targetKey] > 0) {
      setUploadedLines((prevState) => {
        return prevState.map((line) => {
          if (line.documentNo === documentNo && lineNo === line.lineNo) {
            let qtyMissing = line.itemQty - (line.qtyShipped + targetField[targetKey]);
            if (qtyMissing < 0) {
              qtyMissing = 0;
            }
            line.qtyMissing = qtyMissing;
          }
          return line;
        });
      });
    }
  }

  async function validateLines(actionType) {
    let validatedLines = [];
    validatedLines = uploadedLines.map((line) => {
      const currentOrderLines = uploadedLines.filter(
        (targetLine) => targetLine.documentNo === line.documentNo
      );
      return validatePurchaseLine(line, 'supplier', currentOrderLines);
    });
    setUploadedLines(sortLinesByErrors(validatedLines));
    if (validatedLines.filter((line) => !line.isValid).length === 0) {
      const result = await Swal.fire({
        title: 'Are you sure?',
        text: "Please make sure everything is uploaded properly, You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: `Yes, ${actionType} it!`
      });
      if (result.isConfirmed) {
        if (actionType.toLowerCase() === 'save') {
          savePurchaseLine();
        }
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Please fix all lines invalid inputs...'
      });
    }
  }

  async function savePurchaseLine(alsoPost = false) {
    dispatch(loaderActions.show());
    const lines = saveableLines.filter((line) =>
      ['Confirmation Sent to Vendor', 'Confirmed by Vendor'].includes(
        line.vendorPortalStatusCaption
      )
    );
    const batchRequestData = saveableLines.map((line) => {
      const data = {
        vndrShpmntNo: String(line.vndrShpmntNo),
        expectedReceiptDate: line.expectedReceiptDate,
        vendorConfirmQty: Number(line.vendorConfirmQty),
        mfgOriginCountry: line.mfgOriginCountry,
        vpDirectUnitCost: line.vpDirectUnitCost
      };
      return {
        method: 'PATCH',
        url: `purchaseOrderLinesVP('${line.documentNo}',${line.lineNo},'${line.itemNo}')`,
        headers: {
          Company: companyFullName,
          'Content-Type': 'application/json',
          'If-Match': '*'
        },
        body: data
      };
    });
    if (batchRequestData.length > 0) {
      const subOrderRequestCalls = Math.ceil(batchRequestData.length / 50);
      const batchRequestSubData = [];
      for (let i = 0; i < subOrderRequestCalls; i++) {
        const subOrderRequestData = batchRequestData.slice(i * 50, (i + 1) * 50);
        batchRequestSubData.push(subOrderRequestData);
      }
      const responses = [];
      const errors = [];
      const promises = [];
      batchRequestSubData.forEach((RequestSubData) => {
        promises.push(
          API()
            .post('/purchase-batch', { requests: RequestSubData })
            .then((resp) => responses.push(resp))
            .catch((err) => errors.push(err))
        );
      });
      Promise.all(promises)
        .then(() => {
          const dynamicsErrorsList = [];
          responses.forEach((resp) => {
            resp.data.responses.forEach((POLineResponse) => {
              if (POLineResponse.status !== 200) {
                dynamicsErrorsList.push(POLineResponse.body.error);
              }
            });
          });
          setDynamicsSaveErrors(dynamicsErrorsList);
          if (alsoPost === false) {
            if (dynamicsSaveErrors.length > 0 || dynamicsMissingErrors.length > 0) {
              toggleDrawer();
              toggleErrorDrawer();
              dispatch(loaderActions.hide());
            } else {
              toggleDrawer();
              dispatch(loaderActions.hide());
              toast.success('Order lines saved successfully');
            }
          }
        })
        .catch(() => {
          console.log(errors);
        });
    }
  }

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.removeProperty('overflow');
    }
  }, [isOpen]);

  const uploadedRows = uploadedLines.map((line, index) => {
    if (!line.vendorPortalStatusCaption || line.vendorPortalStatusCaption.trim() === '') {
      const targetOrder = uploadedOrders.find((order) => order.docNo === line.documentNo);
      if (targetOrder) {
        line.vendorPortalStatusCaption = targetOrder.vendorPortalStatusCaption;
      } else {
        line.vendorPortalStatusCaption = 'Confirmation Sent to Vendor';
      }
    }
    const currentOrderLines = uploadedLines.filter(
      (targetLine) => targetLine.documentNo === line.documentNo
    );
    return (
      <OrderLine
        documentNo={line.documentNo}
        line={line}
        index={index}
        vendorType={'supplier'}
        key={line.documentNo + '_' + line.lineNo + '_' + line.itemNo}
        type={'purchase'}
        editValue={editValue}
        showSaveButton={false}
        showOrderLink={true}
        directLink={'/purchase-order'}
        orderLines={currentOrderLines}
        isBackendLines={true}
      />
    );
  });

  const saveableLines = (
    isFeedBackLoopEnabled
      ? uploadedLines.filter((line) => line.feedbackStatus !== 'Pending')
      : uploadedLines
  ).filter((line) => !isSeafreightShipped(line));

  return (
    <>
      <Card className="p-4 ">
        <div className="text-center"></div>
        <Card.Body className="p-4">
          <Card.Title>
            <i className="feather icon-upload mt-2" /> &nbsp; Import Supplier PO's
          </Card.Title>
          <Card.Text>
            Please verify Purchase Order (PO) lines before importing. Accuracy matters!, Only
            following fields will be updated if PO exists: <br />
            <li>Vendor Confirm Quantity</li>
            <li>Vendor Shipment Number</li>
            <li>Root Cause</li>
            <li>Expected GRD</li>
          </Card.Text>
          <Button variant="primary" onClick={importPOs}>
            Import Supplier PO's
          </Button>
        </Card.Body>
      </Card>

      <Drawer
        open={isOpen}
        onClose={() => {
          toggleDrawer();
        }}
        direction="right"
        size={'80vw'}
        style={{
          zIndex: '10000',
          overflowX: 'hidden',
          overflowY: 'scroll',
          paddingBottom: '10vh'
        }}
      >
        <div className="p-3">
          <div className="row">
            <div className="col align-self-start">Review Upload</div>
            <div className="col align-self-end text-right" role={'button'}>
              <i
                className="feather icon-x-circle ml-2 mt-2"
                style={{ fontSize: '150%', color: 'red' }}
                onClick={() => {
                  toggleDrawer();
                }}
              />
            </div>
          </div>
          {uploadedLines.length > 0 && (
            <Row className="mt-2 px-2" style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Button variant="info" onClick={() => validateLines('Save')}>
                Save Lines ({saveableLines.length}/{uploadedLines.length})
              </Button>
            </Row>
          )}
        </div>
        {uploadedLines.length > 0 && <div className="row mt-2 px-4">{uploadedRows}</div>}
        {uploadedLines.length > 0 && (
          <Row className="mt-4 px-4" style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button variant="info" onClick={() => validateLines('Save')}>
              Save Lines ({saveableLines.length}/{uploadedLines.length})
            </Button>
          </Row>
        )}
        {uploadedLines.length === 0 && (
          <Row className="mt-4 px-4">
            <Alert variant={'warning'} className="mt-2" style={{ width: '100%' }}>
              <p>The uploaded POs are either posted or contain invalid data. Please review.</p>
            </Alert>
          </Row>
        )}
      </Drawer>

      <Drawer
        open={isErrorDrawerOpen}
        onClose={toggleErrorDrawer}
        direction="right"
        size={'80vw'}
        style={{
          zIndex: '10000',
          overflowX: 'hidden',
          overflowY: 'scroll',
          paddingBottom: '10vh'
        }}
      >
        <div className="p-3">
          <div className="row">
            <div className="col align-self-start">
              <h6>Response Errors</h6>
            </div>
            <div className="col align-self-end text-right" role={'button'}>
              <i
                className="feather icon-x-circle ml-2 mt-2"
                style={{ fontSize: '150%', color: 'red' }}
                onClick={() => {
                  if (isOpen) {
                    toggleDrawer();
                  }
                  toggleErrorDrawer();
                }}
              />
            </div>
          </div>
        </div>
        {dynamicsSaveErrors.length > 0 && (
          <>
            <div className="px-3">
              <div className="row">
                <div className="col align-self-start">
                  <u>Following Errors are recorded while Saving PO's</u>
                </div>
              </div>
            </div>
            <div className="row mt-2 px-4">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Code</th>
                    <th>Message</th>
                  </tr>
                </thead>
                <tbody>
                  {dynamicsSaveErrors.map((err, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{err.code}</td>
                        <td>{err.message}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </>
        )}
        {dynamicsMissingErrors.length > 0 && (
          <>
            <div className="px-3">
              <div className="row">
                <div className="col align-self-start">
                  <u>
                    The following PO lines are either missing from the Dynamics or have already been
                    posted.
                  </u>
                </div>
              </div>
            </div>
            <div className="row mt-2 px-4">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>PO #</th>
                    <th>Line #</th>
                  </tr>
                </thead>
                <tbody>
                  {dynamicsMissingErrors.map((err, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{err.documentNo}</td>
                        <td>{err.lineNo}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </>
        )}
      </Drawer>

      <input
        type="file"
        ref={inputEl}
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.csv"
        onChange={handleFileChange}
        style={{ display: 'none' }}
      />
    </>
  );
}

export default ImportSupplierPOs;
